import React from "react";
import { createBrowserHistory } from "history";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from "react-router-dom";

import HomeRoute, {
  Catalogo,
  Residencial,
  Habitacional,
  Consorcio,
  CentralDocumentos,
  CapAluguel,
  Capitalizacao,
  Empresarial,
  Atendimento,
  Saude,
  SobreNos,
} from "../modules";

import { envs, links } from "../config";
import { GoogleAnalytics } from "../components/GoogleAnalytics/GoogleAnalytics";
import AccessibilityButton from "../components/common/AccessibilityButton";

export const history = createBrowserHistory();

const SetRedirectSharepoint = (url, isFile) => {
  const location = useLocation();
  const fullPath = location.pathname;

  if (url) {
    window.location.href = `${links.sharepoint}${url}`;
  }

  if (isFile && fullPath) {
    window.location.href = `${links.sharepoint}${fullPath}`;
  }

  return <h1>Você está sendo redirecionado!</h1>;
};

const MainRouter = () => {
  return (
    <Router>
      <Switch>
        {envs.enableExampleRoute ? (
          <Route path="/catalogo" component={Catalogo} />
        ) : null}
        <Route path={links.capitalizacao.home} component={Capitalizacao} />
        <Route path={links.consorcio.home} component={Consorcio} />
        <Route path={links.capaluguel.home} component={CapAluguel} />
        <Route path={links.residencial.home} component={Residencial} />
        <Route path={links.habitacional.home} component={Habitacional} />
        <Route path={links.empresarial.home} component={Empresarial} />
        <Route path={links.atendimento} component={Atendimento} />
        <Route path={links.saude.home} component={Saude} />
        <Route path={links.sobreNos.home} component={SobreNos} />
        <Route path="/documentos" component={CentralDocumentos} />
        <Redirect
          from={links.habitacional.emprestimos}
          to={links.habitacional.home}
        />
        <Route path="/" exact component={HomeRoute} />

        {/* Sharepoint Redirects */}
        <Route
          path="/paravoce/saude/Biblioteca*/:filename"
          component={() => {
            return SetRedirectSharepoint(null, true);
          }}
        />
        <Route
          path="/paravoce/saude/Paginas/rede-referenciada.aspx"
          component={() => {
            return SetRedirectSharepoint(
              "/paravoce/saude/Paginas/rede-referenciada.aspx"
            );
          }}
        />
        <Route
          path="/paravoce/saude/Paginas/Reajuste-de-Contrato.aspx"
          component={() => {
            return SetRedirectSharepoint(
              "/paravoce/saude/Paginas/Reajuste-de-Contrato.aspx"
            );
          }}
        />
        <Route
          path="/paravoce/saude/Paginas/resultado-pqo-ans.aspx"
          component={() => {
            return SetRedirectSharepoint(
              "/paravoce/saude/Paginas/resultado-pqo-ans.aspx"
            );
          }}
        />
      </Switch>
      <GoogleAnalytics />
      <AccessibilityButton />
    </Router>
  );
};

MainRouter.propTypes = {};

export default MainRouter;
